const config = require('../config/dev')
module.exports = require('./'+config.default.language+'.js')


// WEBPACK FOOTER //
// ./src/i18/index.js